import React from 'react';
import styles from './styles.scss';

const GridView = () => (
  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.833496 11.6667H19.1668V13.9584H0.833496V11.6667Z" fill="#67696F" />
    <path d="M0.833496 6.16675H19.1668V8.45841H0.833496V6.16675Z" fill="#67696F" />
    <path d="M0.833496 0.666748H19.1668V2.95841H0.833496V0.666748Z" fill="#67696F" />
  </svg>
);

const TableView = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.58333 1.4375C1.95011 1.4375 1.4375 1.95011 1.4375 2.58333V5.5625H16.5625V2.58333C16.5625 1.95011 16.0499
       1.4375 15.4167 1.4375H2.58333ZM17.9375 2.58333C17.9375 1.19072 16.8093 0.0625 15.4167 0.0625H2.58333C1.19072
        0.0625 0.0625 1.19072 0.0625 2.58333V15.4167C0.0625 16.8093 1.19072 17.9375 2.58333 17.9375H15.4167C16.8093
         17.9375 17.9375 16.8093 17.9375 15.4167V2.58333ZM16.5625 6.9375H1.4375V15.4167C1.4375 16.0499 1.95011 16.5625
          2.58333 16.5625H15.4167C16.0499 16.5625 16.5625 16.0499 16.5625 15.4167V6.9375Z"
      fill="#67696F"
    />
  </svg>
);

interface SwitchProps {
  handleChange: () => void;
  checked: boolean;
}
const Switch = ({ handleChange, checked }: SwitchProps) => (
  <div className={styles.switch_wrapper}>
    <input type="checkbox" checked={checked} onChange={() => handleChange()} className={styles.checkbox} />
    <span className={styles.back} />
    <GridView />
    <TableView />
  </div>
);

export default Switch;
